import { GridFooterCellProps } from "@progress/kendo-react-grid";
import { useTheme } from "@mui/material";
import { StopDataFooterProps } from "./StopDataFooterProps";
import { colorShade } from "../../../../../../Layout/Grid/Cell/KendoReactColoredFooterCell";

export default function StopDataDaysMaxCell({
  routings,
  colSpan,
}: StopDataFooterProps & GridFooterCellProps) {
  const theme = useTheme();
  const max = routings.reduce(
    (acc, current) => (current.Day ? Math.max(acc, current.Day) : acc),
    0
  );
  return (
    <td colSpan={colSpan} style={{ backgroundColor: theme.palette.grey[colorShade] }}>
      {max}
    </td>
  );
}
